
import { ToastrService } from 'ngx-toastr';
import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  Output,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  ElementRef
} from '@angular/core';
import { Router } from '@angular/router';

import { takeUntil } from 'rxjs/operators'; import { Subject } from 'rxjs';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { SelectizeComponent, Options } from '../blocks';
import { AuthService, UserSessionService, UIAction, HrParms, sortArrayOnDateProp } from '../shared';
import { FavoriteService, Favorite } from '../security/favorite';
import { Module, ModuleService } from '../modules/modules';
import { ComponentType } from '../modules/component-type';
import { RequestsListService } from '../personnel-setup/requests-list';
import { NotifySignalrService, NotifyMesseage } from '../shared/notify-signalr.service';
import { DOCUMENT } from '@angular/common';
import { HrGeneralizationsAlerts, HrGeneralizationsAlertsService } from '../personnel-setup/hr-generalizations-alerts-setup/hr-generalizations-alerts-setup.service';
import html2canvas from 'html2canvas';

@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  providers: [FavoriteService, RequestsListService]
})
export class dashboardComponent implements OnInit, OnDestroy, OnChanges {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  searchObj = <HrParms>{};
  moduleList: Module[] = [];
  modulesSettings: any = {};
  rootModules: Module[] = [];
  subModules: Module[] = [];
  Links: Module[] = [];
  moduleLinks: Module[];
  moduleLinksFilter: Module[];
  previliges: any[];
  bufferedModuleLinks: any = {};
  showFavArea: boolean = false
  favoLinks: any[] = [];
  @ViewChild('inputElement', { static: true }) private inputElement: ElementRef;
  @Input() child_id: number;
  @ViewChild('linksSelectize')
  linksSelectize: SelectizeComponent;

  public secLoginId: number;
  serial: number;
  linkId: number;
  public branchId = 1;
  public currentUser: number;
  selectedRoot: Module = <Module>{};
  selectedSubModule: Module = <Module>{};
  selecetedLink: Module = <Module>{};
  selecetdLinkType: ComponentType = ComponentType.Favourits;
  linksTypesList: number[] = Object.keys(ComponentType).map(el => +el);
  displayFlag: number;
  styleFlag: number;
  generalizationAndAlerts: any[] = [];
  generalizationAndAlertsObj: any = {};
  @Output()
  LinkClick: EventEmitter<any> = new EventEmitter();
  branchNameAr: any;
  branchNameEn: any;

  @ViewChild('dashboardComponent') dashboardComponent: dashboardComponent;
  favoLinksCopy: any[] = [];
  constructor(
    public translate: TranslateService,
    private _moduleService: ModuleService,
    private _RequestsListService: RequestsListService,
    private _authService: AuthService,
    private _favouriteService: FavoriteService,
    private _USS: UserSessionService,
    private signalrService: NotifySignalrService,
    private toastr: ToastrService,
    private _router: Router,
    private _HrGeneralizationsAlertsService: HrGeneralizationsAlertsService,

    @Inject(DOCUMENT) private document
  ) {
    this.branchId = null;
    this.currentUser = null;
    this.secLoginId = null;
  }
  roles: any[] = [];

  initlize() {
    this.moduleList = [];
    this._moduleService
      .loadPreviliges(this.child_id).pipe(
        takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
          // console.log('setting  previliges');
          this.previliges = res.data;
          this.roles = res.data5;
          //التعميمات والتنبيهات
          if (res.data7) {
            if (res.data7.length > 0) {
              this.generalizationAndAlertsObj = res.data7[0];
              this.generalizationAndAlerts = res.data7;
            }
            else {
              this.generalizationAndAlertsObj.generalizationSerial = 1;
              this.generalizationAndAlertsObj.isReaded = true;

            }
          }
          else {
            this.generalizationAndAlertsObj.generalizationSerial = 1;
            this.generalizationAndAlertsObj.isReaded = true;

          }


          //////////////////////////////////////
          let dummyPrivilage: any = <any>{};
          this.roles.forEach(element => {
            if (!this.previliges || this.previliges.length == 0 || this.previliges == null) {
              dummyPrivilage[element.columnName] = null;
            } else {
              this.previliges.forEach(el => {
                if (element.id == el.roleId) {
                  dummyPrivilage[element.columnName] = el.value;
                } else {
                  if (!dummyPrivilage[element.columnName] || dummyPrivilage[element.columnName] == null) {
                    dummyPrivilage[element.columnName] = null;
                  }
                }
              });
            }
          });
          let tempArr: any[] = [];
          tempArr.push(dummyPrivilage);
          this._USS.setSessionKey(
            'SecLoginPrivileges',
            tempArr
          );
          if (res.data1 && res.data1.length > 0) {
            console.log("From Dashboard Data1 => ", res.data1);
            this._USS.integratesWithWaseelPlatform = res.data1[0].integratesWithWaseelPlatform;
            this._USS.integratesWithNaphisePlatform = res.data1[0].integratesWithNaphisePlatform;
            this._USS.nphiesExtensionTransferDefalutValue = res.data1[0].nphiesExtensionTransferDefalutValue;
            this._USS.currentDataBaseUsed = res.data1[0].dbName ? res.data1[0].dbName : null;
            this._USS.jobTitle = res.data1[0].jobTitle ? res.data1[0].jobTitle : null;

            this._USS.setSessionKey(
              'DashBoardParms',
              res.data1[0]
            );

            this.branchNameEn = res.data1[0]['branchNameEn'];
            this.branchNameAr = res.data1[0]['branchNameAr'];

          }
          if (res.data2 && res.data2.length > 0) {
            this._USS.setSessionKey('attendance', null);
            this._USS.setSessionKey(
              'attendance',
              res.data2[0]['attendance']
            );
          }
          if (res.data3 && res.data3.length > 0) {
            this._USS.setSessionKey('EmpDataFromSession', null);
            this._USS.setSessionKey(
              'EmpDataFromSession',
              res.data3[0]
            );
          }
          if (res.data4 && res.data4.length > 0) {
            this.moduleList = res.data4;
          }
          if (res.data6 && res.data6.length > 0) {
            let _modulesSettings = res.data6;
            this.modulesSettings = {};
            for (let i = 0; i < _modulesSettings.length; i++) {
              const el = _modulesSettings[i];
              if (!this.modulesSettings[`m_${el.moduleId}`]) {
                this.modulesSettings[`m_${el.moduleId}`] = {};
              }
              const fieldName = el.fieldName;
              const fieldValue = el.fieldValue;
              let firstChar = fieldName.charAt(0).toLowerCase();
              let capitalizedKey = firstChar.toUpperCase() + fieldName.slice(1);
              let lowercaseKey = firstChar + fieldName.slice(1);
              this.modulesSettings[`m_${el.moduleId}`][fieldName] = fieldValue;
              this.modulesSettings[`m_${el.moduleId}`][capitalizedKey] = fieldValue;
              this.modulesSettings[`m_${el.moduleId}`][lowercaseKey] = fieldValue;
            }

            console.log("Module Setting abdo= ", this.modulesSettings);
            this._USS.setSessionKey('modulesSettings', this.modulesSettings);
            /////////////////////////////////////global setting in system
            if (this.modulesSettings[`m_${15}`]) {
              this._USS.globalmodulesSettings = this.modulesSettings[`m_${15}`]

              this._USS.globalmodulesSettings.RoundFinancialFigures = this._USS.globalmodulesSettings.RoundFinancialFigures;

            } else {
              this._USS.globalmodulesSettings.RoundFinancialFigures = 4;
            }
          }
        },
        () => { },
        () => {
          if (this.moduleList) {
            this.rootModules = this.moduleList.filter(
              m => m.parentCode == 0 && m.levelNo == 1
            );
            let doloop = true,
              i = 0;
            if (this.rootModules && this.rootModules.length > 0) {
              this.rootModules.forEach(m =>
                m.active = false
              )
              this.rootModules[0].active = true;

              while (doloop) {
                this.selectedRoot = this.rootModules[i];
                const len = this.getSubModules(this.selectedRoot);
                if (len > 0 || i == this.rootModules.length - 1) {
                  doloop = false;
                }
                i = i + 1;
              }
            }
            this._authService.setUserLinks(
              this.moduleList.filter(links => links.levelNo == 3)
            );

            ///sayed  17-8-2024--
            if (this.fastLogin > 0) {

              let link = this.moduleList.filter(el => el.code == this.fastLogin);
              this.onLinkClicked(link[0], null);
            }
            //end
          }
          /*==========================================================================*/
          this.getFavorite();
          /*==========================================================================*/
        }
      );
  }
  HrGeneralizationsAlertsObj: HrGeneralizationsAlerts = <HrGeneralizationsAlerts>{};
  readGeneralizationAndAlerts(obj: any) {
    this.HrGeneralizationsAlertsObj = obj;
    this.HrGeneralizationsAlertsObj.serial = obj.genMasterSerial;
    this.HrGeneralizationsAlertsObj.isRead = 1;
    this._HrGeneralizationsAlertsService.updateHrGeneralizationsAlerts(this.HrGeneralizationsAlertsObj)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(c => {
        if (c && c.returnFlag == true)
          this.initlize();
      });
  }
  downloadGeneralizationAndAlertsPdf() {

  }

  // search in modules by name or code
  searchModules(k: string) {
    this.Links = [];
    const obj =
      this.translate.currentLang == 'ar'
        ? <Module>{ nameAr: k, levelNo: 3, active: true }
        : <Module>{ nameEn: k, levelNo: 3, active: true };
    this._moduleService.searchSubModulesObj(obj).subscribe(
      links => {
        this.Links = links;
      },
      erro => console.log(erro),
      () => { }
    );
  }


  onLinkClicked(link: Module, event: Event) {
    if (event) {
      event.stopPropagation();
    }
    if (
      !this._USS.resetUIState({
        type: UIAction.OpenNewLink,
        payload: ''
      })
    ) {
      return false;
    }
    this._USS.removeLinkKeys(link);
    this._USS.setSessionKey('link', link);

    sessionStorage.setItem("LinkObj", JSON.stringify(link))
    // commented by sayed ahmed
    // localStorage.setItem("LinkObj", JSON.stringify(link))
    // console.log(link.routePath);
    if (link.mode && link.mode.includes('{')) {
      let newMode = JSON.parse(link.mode)
      this._router.navigate([link.routePath, newMode]).then(value => {
        this.LinkClick.emit(null);
      });
    } else {
      this._router.navigate([link.routePath, { mode: link.mode }]).then(value => {
        this.LinkClick.emit(null);
      });
    }
    let docMode = +link.mode;
    let doctorLinks: number[] = [5226, 5407, 10157, 14587];
    if (link.code == 14587) {
      docMode = 1
    }
    if (doctorLinks.includes(link.code) && (docMode == 1 || docMode == 23)) {
      this.translate.use('en');
      this.translate.currentLang = 'en';
      this.translate.defaultLang = 'en';
      this.document.getElementById('ltrCssFile').setAttribute('href', 'assets/css/ltr.css');
      console.time('load doctor css');
      this.loadStyles('assets/css/doctors.css');
      console.timeEnd('load doctor css');
    } else if (doctorLinks.includes(link.code) && docMode == 2) {
      this.loadStyles('assets/css/doctors.css');
    }

    else if (link.code == 10474) {
      this.translate.use('en');
      this.translate.currentLang = 'en';
      this.translate.defaultLang = 'en';
      this.document.getElementById('ltrCssFile').setAttribute('href', 'assets/css/ltr.css');
      console.time('load Vechiles css');
    }

    else {
      this.loadStyles('');
    }
  }

  loadStyles(stylePath: string) {
    const head = this.document.getElementsByTagName('head')[0];
    let doctorLink = this.document.getElementById('doctorCss') as HTMLLinkElement;

    if (doctorLink) {
      doctorLink.href = stylePath;
    } else {
      const style = this.document.createElement('link');
      style.id = 'doctorCss';
      style.rel = 'stylesheets';
      style.href = `${stylePath}`;

      head.appendChild(style);
    }
  }


  ShowUserReports() {
    this._USS.removeLinkKeys({ code: 5293 });
    this._USS.setSessionKey('link', { code: 5293 });
    this._router
      .navigate(['/report/user-report', {}])
      .then(value => {
        this.LinkClick.emit(null);
      });
  }

  onFavourite(module: any, datastatus: number) {
    const currentFavModule = <Favorite>{
      secLoginId: this.currentUser,
      linkId: module.code,
      serial: module.favSerial,
      dataStatus: datastatus
    };
    if (module['isFav']) {
      this._favouriteService.deleteFavorite(currentFavModule)
      this._favouriteService
        .addFavorite(currentFavModule).pipe(
          takeUntil(this.ngUnsubscribe))
        .subscribe(
          res => {
            module['isFav'] = 0;
            this.getFavorite();
          },
          error => console.log(error),
          () => { }
        );
    } else {
      this._favouriteService
        .addFavorite(currentFavModule).pipe(
          takeUntil(this.ngUnsubscribe))
        .subscribe(
          res => {
            module['isFav'] = 1;
            this.getFavorite();
          },
          error => console.log(error),
          () => { }
        );
    }
  }
  //-------------
  getSubModules(currentRootModule: any): number {
    this.subModules = [];
    this.selectedRoot = currentRootModule;
    this.subModules = this.moduleList.filter(
      m => m.parentCode == this.selectedRoot.code && m.levelNo == 2
    );
    if (this.subModules && this.subModules.length > 0) {
      this.selectedSubModule = this.subModules[0];
      // this.subModules[0]['act'] = true;
      this.selectedSubModule['act'] = true;
    }
    return this.subModules.length;
  }
  setModulebyLink() {
    this.getLinks(null, this.selectedSubModule, this.selecetdLinkType);

  }

  onRootModuleClick(_module: any) {

    let active = _module.active;
    this.subModules.forEach(el => el['act'] = false);
    this.rootModules.forEach(element => element.active = false);
    _module.active = !active;
    this.getSubModules(_module);
  }
  codeOfModule: number = 0;
  flagChangeModule: boolean = false
  getLinks(
    event: Event,
    currentSubModule: any,
    currentLinkType: ComponentType,
    type?: number
  ) {
    this._USS.setSessionKey('module', currentSubModule);
    if (type && type == 1) {
      this.subModules.forEach(element => {
        element['act'] = false;
      });
      currentSubModule.act = !currentSubModule.act;
    }
    if (event) {
      event.stopPropagation();
    }
    this.selectedSubModule = currentSubModule;
    this.selecetdLinkType = currentLinkType;
    if (this.selectedSubModule != undefined) {
      const xx = String(this.selectedSubModule.code) + '_' + String(-1);
      if (this.bufferedModuleLinks[xx]) {
        this.moduleLinks = this.bufferedModuleLinks[xx];
        this.moduleLinksFilter = this.bufferedModuleLinks[xx];
      } else {
        this.moduleLinks = this.moduleList.filter(
          m => m.parentCode == this.selectedSubModule.code
        );
        if (!this.moduleLinksFilter || this.flagChangeModule == true) {
          this.moduleLinksFilter = this.moduleList.filter(
            m => m.parentCode == this.selectedSubModule.code
          );
          this.flagChangeModule = false
        }
      }
    }

  }

  bufferLinks() {
    const xx = String(this.selectedSubModule.code) + '_' + String(-1);
    this.bufferedModuleLinks[xx] = this.moduleLinks;
  }

  callLinksServ(linkType: number) { //abdo
    let _subModule = this.selectedSubModule.code || 0;
    this._moduleService
      .getSubModulesTypes(_subModule, linkType).pipe(
        takeUntil(this.ngUnsubscribe))
      .subscribe(c => {
        if (linkType == 5) {
          let favoLinks = c.data;
          this._USS.setSessionKey('toggleFavArea', favoLinks);

        }
      });
  }

  getFavorite() {
    this.callLinksServ(5);
  }

  linksByType(type: number) { }



  selectLinkType(currentLinkType: ComponentType) {
    this.selecetdLinkType = currentLinkType;
    this.getLinks(null, this.selectedSubModule, this.selecetdLinkType);
  }

  ngOnChanges() {
    // create header using child_id
    if (this.child_id && this.child_id > 0) {
      this.moduleLinks = <any>[];
      this.moduleLinksFilter = <any>[];
      this.initlize();
      this.signalrService.connect();
      this.signalrService
        .listen().pipe(
          takeUntil(this.ngUnsubscribe))
        .subscribe(() => {
        });
    }
  }
  fastLogin: number
  ngOnInit() {
    // //get only value from enum to loop
    this.displayFlag = this._USS.displayFlag
    this.styleFlag = this._USS.styleFlag
    this.linksTypesList = this.linksTypesList.slice(
      0,
      this.linksTypesList.length / 2
    );

    //listen in current user object value changes
    const xx = this._authService
      .fetchuserInfo()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(c => {
        if (c) {
          if (this.branchId != c.defaultBranch || this.currentUser != c.userID) {
            this.branchId = c.defaultBranch;
            this.currentUser = c.userID;
            this.initlize();
            this.fastLogin = c.fastLogin;

          }
        }
      });
    //when secLogin change #gouhay
    this._authService.currentUserEmit
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(c => {
        if (c) {
          if (this.branchId != c.defaultBranch || this.currentUser != c.userID) {
            this.branchId = c.defaultBranch;
            this.currentUser = c.userID;
            this.moduleLinks = <any>[];
            this.moduleLinksFilter = <any>[];
            this.initlize();
          }
        }
      });

    this.signalrService.connect();
    this.getNotifyMsg()
    this.subscribeToEvents()
    // this.getNotifyMsg()
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  //--------------
  onmouseover(moodule: any) {
    moodule['hovered'] = true;
  }
  onmouseleave(moodule: any) {
    moodule['hovered'] = false;
  }

  getAllApprovedOrnotApproved() {
    let allApprovedOrnotApprovedData = [];
    this._RequestsListService.getApproverOrnotApprovedReq()
      .subscribe(
        requests => {
          allApprovedOrnotApprovedData = requests.data;
          if (allApprovedOrnotApprovedData && allApprovedOrnotApprovedData.length > 0) {
            this._USS.setSessionKey('notArr', allApprovedOrnotApprovedData);
          }
        },
        error => console.log(error),
        () => {
        });
  }

  getAllApprovedOrnotApprovedAsManger() {
    let allApprovedOrnotApprovedDataAsManger = [];
    this.searchObj.reqType = 0;
    this._RequestsListService.getRequestListData(this.searchObj)
      .subscribe(
        requests => {
          allApprovedOrnotApprovedDataAsManger = requests.data;
          if (allApprovedOrnotApprovedDataAsManger && allApprovedOrnotApprovedDataAsManger.length > 0) {
            this._USS.setSessionKey('notMangerArr', allApprovedOrnotApprovedDataAsManger);
          }
        },
        error => console.log(error),
        () => {
        });
  }

  updateRequest(serial: number) {
    if (serial) {

      this.searchObj.reqSerial = serial;
      this._RequestsListService.updateRequestStatus(this.searchObj)
        .subscribe(
          requests => {
          },
          error => console.log(error),
          () => {

          });
    }
  }
  getNotifyMsg() {
    this.signalrService
      .listen().pipe(
        takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        if (res && res.data2 && res.data2.notificationRepeatInterval > 0) {
          var intervalDataTime = res.data2.notificationRepeatInterval

        }
      });
  }
  subscribeToEvents() {
    this.signalrService.setIntervalTime.subscribe((timeData: any) => {
      console.log("timeData", timeData)
      setInterval(() => {
        this.getAllNotify()
      }, timeData);
    });
  }
  getAllNotify() {
    this.signalrService
      .getAllNotify().pipe(
        takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        if (res && res.data) {
          this._USS.setSessionKey('resetNotificationList', { restAllNotify: true });

          this.signalrService.AddNotifications(res.data)
        }
      });
  }
  flagSort1: boolean = false
  flagSort2: boolean = false
  flagSort3: boolean = false
  filterCompByName(linkType: any) {
    if (linkType == 1) {
      this.flagSort1 = !this.flagSort1
      this.filterComp(linkType, this.flagSort1)
    }
    if (linkType == 2) {
      this.flagSort2 = !this.flagSort2
      this.filterComp(linkType, this.flagSort2)
    }
    if (linkType == 3) {
      this.flagSort3 = !this.flagSort3;
      this.filterComp(linkType, this.flagSort3)
    }

  }
  filterComp(linkType: any, flag: boolean) {
    let newArr = []
    let newArrIndex = []
    this.moduleLinksFilter.forEach((element, index) => {
      if (element.compType == linkType) {
        newArrIndex.push(index)
      }
    });
    let lang = 'nameAr'
    if (this.translate.currentLang == 'ar') {
      lang = 'nameAr'
    } else {
      lang = 'nameEn'
    }
    newArrIndex = newArrIndex.sort((x, y) => {
      if (flag == true) {
        if (this.moduleLinksFilter[x][lang] > this.moduleLinksFilter[y][lang]) { return 1 }
        else if (this.moduleLinksFilter[x][lang] < this.moduleLinksFilter[y][lang]) { return -1; }
        else { return 0; }
      } else {
        if (this.moduleLinksFilter[x][lang] < this.moduleLinksFilter[y][lang]) { return 1 }
        else if (this.moduleLinksFilter[x][lang] > this.moduleLinksFilter[y][lang]) { return -1; }
        else { return 0; }
      }
    })
    newArrIndex.forEach(element => {
      newArr.push(this.moduleLinksFilter[element]);
    });
    newArrIndex = newArrIndex.sort((x, y) => {
      if (x > y) { return 1 }
      else if (x < y) { return -1; }
      else { return 0; }
    })
    newArrIndex.forEach((element, index) => {
      this.moduleLinksFilter[element] = newArr[index]
    });
  }
  // onLinkClick(link: Module, event: Event) {
  //   this.dashboardComponent.onLinkClicked(link, event);
  // }

  favSearchOnkeyEnter(value: any) {
    let valueAsNumber = +value;
    if (!isNaN(valueAsNumber) && valueAsNumber > 0) {
      let indx = this.favoLinksCopy.findIndex((el, index) => el.sortView == valueAsNumber);
      if (indx != -1) {
        let linkObject = this.favoLinksCopy[indx];
        if (linkObject && Object.keys(linkObject)) {
          this.onLinkClicked(linkObject, null);
          this.showFavArea = !this.showFavArea;
        }

      }

    }
  }
  toggleFavArea() {
    this._USS.subscribeToKey$('toggleFavArea')
      .subscribe((keys: any) => {
        if (keys && keys.value) {
          this.favoLinks = keys.value;
          this.favoLinksCopy = Object.assign([], this.favoLinks);
          //    this.showFavArea = !this.showFavArea;
          this.inputElement.nativeElement.focus();
          this.inputElement.nativeElement.select();
        }
      })
  }
}
